import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const MoveMoney = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <StyledImage
            src={messages['home.move.image.src']}
            alt={messages['home.move.image.alt']}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.move.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.move.paragraph" />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default MoveMoney;
